﻿(function (document) {

    var $button = document.querySelector('.input--with-icon > i[role=button]');

    if ($button == null || typeof $button == 'undefined') {
        return;
    }

    var $input = $button.parentElement.querySelector('input');

    var $associatedButton;
    if (!($button.dataset.associatedButton == null
        || typeof $button.dataset.associatedButton == 'undefined'
        || $button.dataset.associatedButton.length == 0
    )) {
        $associatedButton = document.querySelector($button.dataset.associatedButton);
    }

    $button.addEventListener('click', function (e) {
        if ($associatedButton == null
            || typeof $associatedButton == 'undefined'
        ) {
            var ke = new KeyboardEvent('keydown', {
                bubbles: true,
                cancelable: true,
                keyCode: 13
            });
            $input.focus();
            $input.dispatchEvent(ke);
        } else {
            $associatedButton.click();
        }
    });
})(document);